import { render, staticRenderFns } from "./moreDialog.vue?vue&type=template&id=a45ef560&scoped=true"
import script from "./moreDialog.vue?vue&type=script&lang=js"
export * from "./moreDialog.vue?vue&type=script&lang=js"
import style0 from "./moreDialog.vue?vue&type=style&index=0&id=a45ef560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45ef560",
  null
  
)

export default component.exports